import { useState, useMemo } from "react";
import { authService } from "../dependencyInjection";
import { RequestStatus, CheckLifeTimeTypeLinks } from "../services/AuthService";

export type UseCheckLifeTimeLink = (userId: number, checkLifeTimeTypeLinks: CheckLifeTimeTypeLinks) => Promise<void>;

export function useCheckLifeTimeLink(): [RequestStatus, UseCheckLifeTimeLink] {
  const [status, setStatus] = useState(RequestStatus.None);
  const checkLifeTimeLink: UseCheckLifeTimeLink = useMemo(
    () => async (userId, checkLifeTimeTypeLinks: CheckLifeTimeTypeLinks) => {
      setStatus(RequestStatus.Pending);
      try {
        await authService.checkLifeTimeLink(userId, checkLifeTimeTypeLinks);
        setStatus(RequestStatus.Success);
      } catch (err) {
        setStatus(RequestStatus.Fail);
      }
    },
    [],
  );

  return [status, checkLifeTimeLink];
}
